function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default function TrovoBrand(props) {
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 752 204",
        fill: "currentColor"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M515.551 39.905C518.333 39.905 520.187 40.8322 520.187 43.614L516.479 106.669L546.15 40.8322C547.078 38.9777 548.932 38.0504 550.787 38.0504H605.495C607.349 38.0504 609.203 39.905 609.203 41.7595C609.203 42.6868 609.203 42.6868 609.203 43.614L537.805 201.251C536.878 203.105 535.023 204.033 533.169 204.033H457.134C454.353 204.033 452.498 202.178 452.498 199.396L462.698 44.5413C462.698 41.7595 464.552 39.905 467.334 39.905H515.551ZM254.994 39.905L250.358 59.3777C257.64 52.0948 266.121 42.6868 275.393 39.905H324.538C327.032 39.905 329.435 41.7595 326.392 44.5413C311.556 54.7413 299.502 63.0868 292.084 71.4326C286.52 76.9962 280.03 86.269 273.539 100.178L267.975 115.014L263.339 131.705L248.503 200.324C248.503 202.178 245.721 204.033 243.867 204.033H188.232C185.45 204.033 183.596 202.178 183.596 199.396V198.469L216.049 43.614C216.049 41.7595 218.831 39.905 220.686 39.905H254.994ZM369.046 38.9777C414.481 38.9777 450.644 75.1417 450.644 120.578C450.644 166.014 414.481 202.178 369.046 202.178C323.61 202.178 287.448 166.014 287.448 120.578C287.448 75.1417 323.61 38.9777 369.046 38.9777ZM670.402 38.9777C715.837 38.9777 752 75.1417 752 120.578C752 166.014 715.837 202.178 670.402 202.178C624.967 202.178 588.804 166.014 588.804 120.578C588.804 75.1417 624.967 38.9777 670.402 38.9777ZM369.046 94.6144C354.21 94.6144 343.083 106.669 343.083 120.578C343.083 134.487 355.137 146.542 369.046 146.542C382.954 146.542 395.009 134.487 395.009 120.578C395.009 106.669 383.882 94.6144 369.046 94.6144ZM140.942 0.0322266C143.724 0.0322266 145.578 1.88677 145.578 4.66859V5.59586L139.088 35.2686C139.088 36.1959 140.015 38.0504 140.942 38.0504C140.942 38.0504 140.942 38.0504 141.869 38.0504H201.213C203.995 38.0504 206.705 39.905 205.85 43.614L191.941 102.033C191.014 104.814 189.159 105.742 186.377 105.742L153.924 103.887C143.724 103.887 132.597 106.669 124.252 115.942C113.125 127.069 112.197 143.76 116.834 155.814C121.47 167.869 134.451 174.36 147.433 171.578C157.633 169.724 163.196 159.524 162.269 151.178C161.342 141.905 157.633 139.124 152.069 139.124C146.506 139.124 144.651 141.905 144.651 144.687C144.651 147.469 145.578 149.324 147.433 151.178C150.215 153.96 144.651 162.305 137.233 157.669C132.597 154.887 129.815 149.323 130.742 140.978C131.67 130.778 140.015 121.505 154.851 121.505C169.687 121.505 180.814 130.778 183.596 144.687C188.232 162.305 178.959 183.633 157.633 194.76C131.67 208.669 88.0888 207.742 63.9799 181.778C50.0712 166.942 45.4349 147.469 46.3622 129.851C46.3622 124.287 47.2894 117.796 49.1439 112.233C49.1439 110.378 48.2167 108.524 46.3622 107.596H4.63589C1.85413 107.596 -0.000366211 104.814 -0.000366211 102.033V101.105L12.9811 44.5413C13.9084 40.8322 16.6901 38.9777 20.3991 38.9777H60.2709C62.1254 38.0504 63.9799 37.1231 64.9072 34.3413L71.3979 5.59586C72.3252 1.88677 76.0345 0.0322266 78.8163 0.0322266H140.942ZM670.402 94.6144C685.238 94.6144 696.365 106.669 696.365 120.578C696.365 134.487 684.311 146.542 670.402 146.542C656.493 146.542 644.439 134.487 644.439 120.578C644.439 106.669 656.493 94.6144 670.402 94.6144Z",
            fill: "currentColor"
        })
    }));
}
